import React, { useState } from 'react';
import { Button } from './ui/Button';
import { Input } from './ui/Input';
import { Mail, CheckCircle } from 'lucide-react';
export function EmailSignup() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'success'>('idle');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (email) {
      setStatus('success');
      // No backend integration as requested
    }
  };
  if (status === 'success') {
    return <div className="bg-green-50 rounded-2xl p-8 text-center border border-green-100 max-w-2xl mx-auto" data-id="element-1">
        <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-2">
          <CheckCircle className="w-8 h-8 text-green-600" data-id="element-3" />
        </div>
        <h3 className="text-2xl font-bold text-green-800 mb-2" data-id="element-4">
          You're on the list!
        </h3>
        <p className="text-green-700" data-id="element-5">
          Thank you for subscribing to our exclusive offers.
        </p>
        <button onClick={() => setStatus('idle')} className="mt-6 text-sm font-medium text-green-600 hover:text-green-800 underline" data-id="element-6">
          Register another email
        </button>
      </div>;
  }
  return <div className="bg-gradient-to-br from-gray-900 to-gray-800 rounded-2xl p-8 md:p-12 text-white shadow-2xl max-w-4xl mx-auto relative overflow-hidden" data-id="element-7">
      {/* Decorative background elements */}
      <div className="absolute top-0 right-0 -mt-10 -mr-10 w-40 h-40 bg-orange-500 rounded-full opacity-20 blur-3xl" data-id="element-8"></div>
      <div className="absolute bottom-0 left-0 -mb-10 -ml-10 w-40 h-40 bg-blue-500 rounded-full opacity-20 blur-3xl" data-id="element-9"></div>

      <div className="relative z-10 text-center" data-id="element-10">
        <div className="inline-flex items-center justify-center p-3 bg-white/10 rounded-xl mb-6 backdrop-blur-sm" data-id="element-11">
          <Mail className="w-8 h-8 text-orange-400" data-id="element-12" />
        </div>

        <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-13">
          Stay Updated on New Offers & Gifts
        </h2>
        <p className="text-gray-300 mb-8 max-w-xl mx-auto text-lg" data-id="element-14">
          Don't miss out on the next big giveaway. Join our exclusive list to
          get notified about new worldwide offers first.
        </p>

        <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-4 max-w-lg mx-auto" data-id="element-15">
          <Input type="email" placeholder="Enter your email address" required value={email} onChange={e => setEmail(e.target.value)} className="bg-white/10 border-white/20 text-white placeholder:text-gray-400 focus:ring-orange-500 focus:border-orange-500" data-id="element-16" />
          <Button type="submit" variant="primary" size="lg" className="whitespace-nowrap sm:w-auto w-full" data-id="element-17">
            Subscribe Now
          </Button>
        </form>

        <p className="mt-6 text-sm text-gray-500" data-id="element-18">
          We respect your privacy. Unsubscribe anytime.
        </p>
      </div>
    </div>;
}